import { default as RList } from "./RList";

export default RList;
